import React from "react";
import "./SecondarySectionStyle.scss";

const SecondarySection = ({ children, className }) => {
  return <div className={`secondary-container ${className}`}>{children}</div>;
};

export default SecondarySection;
